var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 122,
    viewBox: "0 0 74 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0615 25.87C36.0615 42.6233 42.3615 51 54.9615 51C61.6348 51 66.4415 48.76 69.3815 44.28C72.3215 39.8 73.7915 33.6633 73.7915 25.87C73.7915 18.1233 72.3215 12.01 69.3815 7.53C66.4415 3.05 61.6348 0.809999 54.9615 0.809999C42.3615 0.809999 36.0615 9.16333 36.0615 25.87ZM64.0615 25.87C64.0615 30.9567 63.4315 34.8767 62.1715 37.63C60.9582 40.3367 58.5548 41.69 54.9615 41.69C51.3215 41.69 48.8715 40.3367 47.6115 37.63C46.3982 34.8767 45.7915 30.9567 45.7915 25.87C45.7915 20.83 46.3982 16.9567 47.6115 14.25C48.8715 11.4967 51.3215 10.12 54.9615 10.12C58.5548 10.12 60.9582 11.4967 62.1715 14.25C63.4315 16.9567 64.0615 20.83 64.0615 25.87ZM36.662 101.63H23.572V114.93H14.052V101.63H0.961953V92.6H14.052V79.23H23.572V92.6H36.662V101.63ZM54.7345 81.82V72.58H72.5145V122H62.1545V81.82H54.7345Z",
    fill: "#130F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8945 129H76.9945V132.5H53.8945V129Z",
    fill: "#130F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramImage1);
export default __webpack_public_path__ + "static/media/programImage1.fff48ac212131d87dac6b7e4343f01a6.svg";
export { ForwardRef as ReactComponent };